/*@ngInject*/
const FormDropdownHandleActiveIndexDirective = function (formViewerConstant) {

    return {
        require: 'uiSelect',
        link: function ($scope, $element, attrs, $select) {
            $scope.$on(formViewerConstant.event.DROPDOWN_UPDATE_ACTIVE_INDEX, function (e, activeIndex) {
                $select.activeIndex = activeIndex;
            });
        }
    };
};

angular.module('umCore')
    .directive('dropdownHandleActiveIndex', FormDropdownHandleActiveIndexDirective);
